/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskExclusionsDelete } from "../funcs/riskExclusionsDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteRiskExclusionRequest,
  DeleteRiskExclusionSecurity,
} from "../models/operations/deleteriskexclusion.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskDeleteExclusionMutationVariables = {
  request: DeleteRiskExclusionRequest;
  security?: DeleteRiskExclusionSecurity | undefined;
  options?: RequestOptions;
};

export type RiskDeleteExclusionMutationData = void;

export type RiskDeleteExclusionMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteRiskExclusion risk
 *
 * @remarks
 * Delete a risk exclusion. Previously suppressed findings are restored.
 */
export function useRiskDeleteExclusionMutation(
  options?: MutationHookOptions<
    RiskDeleteExclusionMutationData,
    RiskDeleteExclusionMutationError,
    RiskDeleteExclusionMutationVariables
  >,
): UseMutationResult<
  RiskDeleteExclusionMutationData,
  RiskDeleteExclusionMutationError,
  RiskDeleteExclusionMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskDeleteExclusionMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskDeleteExclusion(): MutationKey {
  return ["@gram/client", "exclusions", "delete"];
}

export function buildRiskDeleteExclusionMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskDeleteExclusionMutationVariables,
  ) => Promise<RiskDeleteExclusionMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskDeleteExclusion(),
    mutationFn: function riskDeleteExclusionMutationFn({
      request,
      security,
      options,
    }): Promise<RiskDeleteExclusionMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskExclusionsDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
